import o from "./index213.mjs";
import t from "./index205.mjs";
import m from "./index212.mjs";
function u(r) {
  if (m(1, arguments), !o(r) && typeof r != "number")
    return !1;
  var e = t(r);
  return !isNaN(Number(e));
}
export {
  u as default
};
//# sourceMappingURL=index168.mjs.map
